import React, { useState, useEffect } from 'react';
import { Input } from './input';
import { formatarDataBR, dataBRparaISO } from '../../utils/dateUtils';

/**
 * Input de data que exibe no formato brasileiro (dd/mm/yyyy)
 * Internamente usa formato ISO (yyyy-mm-dd) para compatibilidade
 */
const InputDataBR = ({ 
  value, 
  onChange, 
  placeholder = 'dd/mm/aaaa',
  className = '',
  ...props 
}) => {
  const [displayValue, setDisplayValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  // Quando o valor ISO muda, atualiza o display
  useEffect(() => {
    if (value && !isFocused) {
      setDisplayValue(formatarDataBR(value));
    }
  }, [value, isFocused]);

  // Máscara de entrada para dd/mm/yyyy
  const handleInputChange = (e) => {
    let input = e.target.value.replace(/\D/g, ''); // Remove não-dígitos
    
    // Aplicar máscara
    if (input.length > 0) {
      if (input.length <= 2) {
        input = input;
      } else if (input.length <= 4) {
        input = `${input.slice(0, 2)}/${input.slice(2)}`;
      } else {
        input = `${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4, 8)}`;
      }
    }
    
    setDisplayValue(input);

    // Se tiver data completa (dd/mm/yyyy), converter para ISO
    if (input.length === 10) {
      const [dia, mes, ano] = input.split('/');
      
      // Validar data
      const diaNum = parseInt(dia, 10);
      const mesNum = parseInt(mes, 10);
      const anoNum = parseInt(ano, 10);
      
      if (diaNum >= 1 && diaNum <= 31 && mesNum >= 1 && mesNum <= 12 && anoNum >= 1900 && anoNum <= 2100) {
        const isoDate = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        onChange && onChange({ target: { value: isoDate } });
      }
    } else if (input.length === 0) {
      onChange && onChange({ target: { value: '' } });
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
    // Se tiver valor ISO, mostrar no formato BR para edição
    if (value) {
      setDisplayValue(formatarDataBR(value));
    }
  };

  const handleBlur = () => {
    setIsFocused(false);
    // Validar e formatar ao sair
    if (displayValue.length === 10) {
      const [dia, mes, ano] = displayValue.split('/');
      const diaNum = parseInt(dia, 10);
      const mesNum = parseInt(mes, 10);
      const anoNum = parseInt(ano, 10);
      
      if (diaNum >= 1 && diaNum <= 31 && mesNum >= 1 && mesNum <= 12 && anoNum >= 1900 && anoNum <= 2100) {
        const isoDate = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        onChange && onChange({ target: { value: isoDate } });
        setDisplayValue(formatarDataBR(isoDate));
      } else {
        // Data inválida - limpar
        setDisplayValue('');
        onChange && onChange({ target: { value: '' } });
      }
    } else if (displayValue.length > 0 && displayValue.length < 10) {
      // Entrada incompleta - limpar
      setDisplayValue('');
      onChange && onChange({ target: { value: '' } });
    }
  };

  return (
    <Input
      type="text"
      inputMode="numeric"
      value={displayValue}
      onChange={handleInputChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      placeholder={placeholder}
      maxLength={10}
      className={`font-mono ${className}`}
      {...props}
    />
  );
};

export { InputDataBR };
export default InputDataBR;
